import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  sub?: string;
  dark?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  sub,
  dark = false,
  className = ""
}: CtaButtonProps) {
  return <div id={id} className={`mx-auto w-full max-w-xl ${className}`} data-id="element-21" data-mp="cjrdec1vely2">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-display text-lg font-bold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#9f1239] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-1 active:shadow-[0_2px_0_0_#9f1239] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-sun sm:text-xl" data-id="element-22" data-mp="qkad8vw6mlp5">
        <span className="[text-wrap:balance]" data-id="element-23" data-mp="159q5yhf9x17h">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-24" data-mp="15baxdy6ak414" />
      </a>
      {sub && <p className={`mt-4 text-center text-sm font-semibold ${dark ? "text-white/80" : "text-ink-soft"}`} data-id="element-25" data-mp="39zsr7njpep3d">{sub}</p>}
    </div>;
}